import React, { Component } from "react";
import {
  TextareaItem,
  WhiteSpace,
  WingBlank,
  Button,
  List,
  Flex,
  Badge,
} from "antd-mobile";
import moment from "moment";
const Item = List.Item;
const container = {
  height: "200px",
  overflowY: "scroll",
};
const flexStyle = {
  textAlign: "right",
  margin: "5px",
}
const pStyle = {
  fontSize: "14px",
  margin: "5px 0",
}
export class ImMeassage extends Component {
  state = {
    messages: '',
    messageList: [],
  };

  componentDidMount() {
    const { ids } = this.props;
    if (ids) {
      const id = ids[0];
      if (id) {
        const messageList = JSON.parse(localStorage.getItem(id.toString()));
        this.setState({
          messageList: messageList || [],
        })
      }
    }
  }

  sendMessage() {
    const { messages, messageList } = this.state;
    if (messages.trim() != "") {
      const time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
      const msg = { time, messages: messages }
      messageList.push(msg);
      this.props.ids.forEach(element => {
        this.saveMessageRecords(element, msg);
      });

      this.props.sendMessage(messages);
      this.setState({
        messages: '',
      })
      this.scrollToBottom();
    }
  }

  saveMessageRecords = (dataKey, msg) => {
    let messageRecords = JSON.parse(localStorage.getItem(dataKey.toString()));
    if (!messageRecords) {
      messageRecords = [];
    }
    if (messageRecords.length >= 10) {
      console.log(messageRecords);
      messageRecords.shift();
    }
    messageRecords.push(msg);
    localStorage.setItem(dataKey.toString(), JSON.stringify(messageRecords));
  }

  scrollToBottom = () => {
    //延时100毫秒等dom渲染完成
    setTimeout(function () {
      let msg = document.querySelector('.am-textarea-control');
      if (msg) {
        console.log(msg.scrollTop, msg.scrollHeight)
        msg.scrollTop = msg.scrollHeight;
      }
    }, 100)
  }

  setMessage = val => {
    console.log(val)
    this.setState({
      messages: val,
    })
  }

  render() {
    const { messageList } = this.state;
    const { type } = this.props;
    return (
      <div>
        <div className="top">
          <List renderHeader={() => "消息通知"}>
            <div className="am-list-item am-textarea-item am-textarea-focus">
              <div className="am-textarea-control" style={{ ...container }}>
                {messageList.map(item =>
                  <Flex key={item.time} style={{ ...flexStyle }}>
                    <Flex.Item>
                      <p style={{ ...pStyle }}>{item.time}</p>
                      <Button type="primary" inline size="small">{item.messages}</Button>
                    </Flex.Item>
                  </Flex>)}
              </div>
            </div>
            <TextareaItem
              placeholder="请输入少于32字符的信息"
              rows={2}
              count={32}
              value={this.state.messages}
              onChange={val => this.setMessage(val)}
            />
            <Item>
              <Button type="primary" onClick={() => this.sendMessage()}>
                发送
              </Button>
              <WhiteSpace size="lg" />
              <Button onClick={this.props.closeIm}>返回</Button>
            </Item>
          </List>
        </div>
      </div>
    );
  }
}

export default ImMeassage;
